<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii"><span class="line">CONTENTS</span></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/08_Preface">Preface: From Empire to Where?</a></p>
<p class="toc"><a href="#/xhtml/09_Fm02">Prime Ministers from 1945</a></p>
<p class="tocb"><a href="#/xhtml/10_Abbreviations">Abbreviations</a></p>
<p class="toc1"><a href="#/xhtml/12_Chapter01"><b>1.</b> Environment under Strain</a></p>
<p class="toc1"><span href="#/xhtml/13_Chapter02" title="Link target outside of Sample"><b>2.</b> Economy under Strain</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter03" title="Link target outside of Sample"><b>3.</b> Changing Society</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter04" title="Link target outside of Sample"><b>4.</b> Changing Culture</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter05" title="Link target outside of Sample"><b>5.</b> The After-Echoes of War, 1945–60</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter06" title="Link target outside of Sample"><b>6.</b> The Politics of Crisis, 1961–79</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter07" title="Link target outside of Sample"><b>7.</b> Thatcherism, 1979–90</span></p>
<p class="toc1"><span href="#/xhtml/19_Chapter08" title="Link target outside of Sample"><b>8.</b> Changing Directions, 1990–2016</span></p>
<p class="toc1"><span href="#/xhtml/20_Chapter09" title="Link target outside of Sample"><b>9.</b> British Issues, 1945–2016</span></p>
<p class="toc1"><span href="#/xhtml/21_Chapter10" title="Link target outside of Sample"><b>10.</b> European and World Questions</span></p>
<p class="toc1"><span href="#/xhtml/22_Chapter11" title="Link target outside of Sample"><b>11.</b> Into the Future</span></p>
<p class="tocb"><span href="#/xhtml/23_Chapter12" title="Link target outside of Sample"><b>12.</b> Conclusions</span></p>
<p class="toc"><span href="#/xhtml/24_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/25_Bibliography" title="Link target outside of Sample">Selected Further Reading</span></p>
<p class="toc"><span href="#/xhtml/26_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?1dbc68aa